import { connect } from "react-redux";
import ContractSalesListing from "./approvedSalesListing";
import { bindActionCreators } from "redux";
import { getApprovedSaleListing } from "services/redux/sales/contractListing/action";

import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  postSalesList: state.contractListingReducer.contractpostSalesList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getApprovedSaleListing,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ContractSalesListing);
